import { $, $$, $$$, breakpoint, bodyScroll, focusTrapping, setElementFocus } from 'dlr-utils/helpers';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-navigation';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
// const ELEMENT = INSTANCES[0];

/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-sample" exists
 */
const IS_EXPANDED = '--is-expanded';
const IS_COLLAPSED = '--is-collapsed';
const IS_FIXED = '--is-fixed';
const IS_DOCKED = '--is-nav-docked';
const IS_ACTIVE = '--is-active';
const IS_PREVIOUS_ACTIVE = '--is-previous-active';
const IS_PARENTLIST_ACTIVE = '--is-parentlist-expanded'; // container expansion
const IS_EXPANDED_FROM_MAINLINK = '--is-expanded-from-mainlink';
const IS_UP = 'up';
const IS_DOWN = 'down';
const NO_DURATION = '--no-duration';
const NO_SCROLL = '--no-scroll';
const SHOW_NAV_AT_PERCENT = 10;
const HIDE_NAV_AT_PERCENT = 10;

const _body = document.body.classList;
const nav = $(SELECTOR);
const _nav = nav.classList;
const menuBtn = $('.dlr-navigation__menu-btn', nav);
const mainMenuLinks = $$('.dlr-navigation__main a.--has-children', nav);
const mainSearchBtn = $('.dlr-navigation__main li.--search button', nav);

const menuList = $('.dlr-navigation__menulist', nav);
const menuListsContainer = $('.dlr-navigation__menulist-scroller', nav);
const listContainer = $$('ul.dlr-navigation__links', menuList);
const listLinks = $$('a.--has-children, button.--back-btn', menuList);
const parentListLinks = $$('a.--parent', menuList);
const parentListLinksWithChildList = $$('a.--parent.--has-children', menuList);
const menuSearchForm = $('.dlr-navigation__search-form', menuList);
const searchField = $('.dlr-navigation__search-form-textfield input', menuList);



let listLinksTree = [];
let lastBreakpoint = null;
let lastScrollTop = window.screenY;


export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscribers
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;


    /* Listening to a custom event */
    MessageBus.subscribe('MENU_HANDLER', obj => {
      const ariaProps = (isExpanded = true) => {
        const toHide = $$(`.a11y-skip, .dlr-navigation__main-links, main.main, footer.dlr-footer`);
        const noFocus = $$('.dlr-navigation__logo, .dlr-navigation__main-links a, .dlr-navigation__main-links button');

        // hide elements for VO when nav expanded;
        toHide.forEach(item => item.setAttribute('aria-hidden', isExpanded));

        //
        noFocus.forEach(item => isExpanded ? item.setAttribute('tabindex', -1) : item.removeAttribute('tabindex'));

        menuBtn.setAttribute('aria-expanded', isExpanded);
        menuBtn.setAttribute('aria-label', `${isExpanded ? 'Close' : 'Open'} the navigation`);
        nav.setAttribute('aria-modal', isExpanded);
      };

      const resetMenulist = () => {
        const listContainers = $$(`ul[list-id]`, menuList);
        const activeLinks = $$(`a.${IS_ACTIVE}`, menuList);
        const parentListContainer = $(`ul[list-id="0"]`, menuList);

        listContainers.forEach(list => list.classList.remove(IS_ACTIVE, IS_PREVIOUS_ACTIVE, IS_EXPANDED, IS_COLLAPSED, IS_EXPANDED_FROM_MAINLINK));
        activeLinks.forEach(link => link.classList.remove(IS_ACTIVE));
        nav.classList.remove(IS_PARENTLIST_ACTIVE);

        if (obj.noActiveMenu) {
          parentListContainer.classList.add(IS_ACTIVE);
        } else {
          setTimeout(() => parentListContainer.classList.add(IS_ACTIVE), 850);
        }
      };

      // EXPAND
      if (!_nav.contains(IS_EXPANDED)) {
        !_nav.contains(IS_FIXED) && window.scrollTo(0, 0);
        ariaProps(true);
        bodyScroll(false)
        _nav.remove(IS_COLLAPSED);
        _nav.add(IS_EXPANDED);
        menuList.scrollTo(0, 0);
        focusTrapping(nav, true);
        resetMenulist();
        searchField.value = '';
        return;
      }

      // COLLAPSE
      ariaProps(false);
      bodyScroll(true);
      focusTrapping(nav, false);
      _nav.remove(IS_EXPANDED);
      _nav.add(IS_COLLAPSED);
      setTimeout(() => _nav.remove(IS_COLLAPSED), 300);
      window.dispatchEvent(new Event('scroll'));
    });


    MessageBus.subscribe('INIT_LISTCONTAINER_HANDLER', event => {
      listContainer.forEach((list, index) => {
        // assign list id
        list.setAttribute('list-id', index);

        const parentLink = list.previousElementSibling;
        const backBtn = $('button', list) || null;
        const parentListId = parentLink ? parentLink.closest('ul').getAttribute('list-id') : null;

        // assign list id to show to clickable element to display list
        parentLink && parentLink.setAttribute('show-list', index);
        parentLink && backBtn.setAttribute('show-list', parentListId);

        // add delay n per LI element


        const LIs = $$(':scope > li', list)
        let delay = 70;
        LIs.forEach((li, index) => li.style.setProperty('--delay', `${delay * (index + 1)}ms`));
      });
    });

    MessageBus.subscribe('LISTCONTAINER_POSITIONING_HANDLER', event => {
      listContainer.forEach(list => menuListsContainer.append(list));
      if (breakpoint() == 'mobile') return;

      setTimeout(() => {
        parentListLinksWithChildList.forEach(parentLink => {
          const parent = parentLink.parentNode;
          const childListId = parentLink.getAttribute('show-list');
          const childListContainer = $(`ul[list-id="${childListId}"]`);

          parent.append(childListContainer);
        });
      }, 100);
    });

    MessageBus.subscribe('LISTLINKS_HANDLER', obj => {
      obj.event.preventDefault();

      const { event, target, delay } = obj;
      const { clientX, clientY } = event;
      const keyed = !clientX && !clientY; // key pressed
      const id = target.getAttribute('show-list');

      const activeListContainer = $(`ul[list-id].${IS_ACTIVE}`, menuList);
      const targetListContainer = $(`ul[list-id="${id}"]`, menuList);
      const backBtn = $('.--back-btn', targetListContainer);
      const activeParentLink = $(`a.--parent.${IS_ACTIVE}`, menuList);
      let parentLink;

      // remove trapping on previous active
      focusTrapping(activeListContainer, false);

      // forward navigating
      if (!target.classList.contains('--back-btn')) {
        activeListContainer.classList.remove(IS_ACTIVE);
        activeListContainer.classList.add(IS_PREVIOUS_ACTIVE);
        targetListContainer.classList.remove(IS_PREVIOUS_ACTIVE, IS_EXPANDED);

        // for desktop add delay on displaying 2nd level list
        if (target.classList.contains('--parent') && breakpoint() == 'desktop' && !nav.classList.contains(IS_PARENTLIST_ACTIVE)) {
          setTimeout(() => targetListContainer.classList.add(IS_ACTIVE), 600);
        } else {
          targetListContainer.classList.add(IS_ACTIVE);
        }
      } else {
        // bckward navigating
        activeListContainer.classList.add(IS_COLLAPSED);
        setTimeout(() => {
          activeListContainer.classList.remove(IS_COLLAPSED, IS_PREVIOUS_ACTIVE, IS_ACTIVE);
          targetListContainer.classList.remove(IS_PREVIOUS_ACTIVE);
          targetListContainer.classList.add(IS_EXPANDED, IS_ACTIVE);
        }, 300);
      }

      // if current target is from parent list, reset listLinksTree array and previous active state
      // and set new active
      if (target.classList.contains('--parent')) {
        listLinksTree = [];
        activeParentLink && activeParentLink.classList.remove(IS_ACTIVE);
        nav.classList.add(IS_PARENTLIST_ACTIVE);
        target.classList.add(IS_ACTIVE);
      }

      // for setting focus on first clickable element
      // or back to previous parent element
      if (!target.classList.contains('--back-btn')) {
        listLinksTree.push(target);

        setTimeout(() => setElementFocus(targetListContainer), delay);
      } else {
        parentLink = listLinksTree.pop();
        setTimeout(() => parentLink.focus(), 350);
      }

      // apply focus traping for 3rd level menu for tablet/desktop
      if (breakpoint() != 'mobile') {
        const parentTargetLinkContainer = targetListContainer.closest('ul.--parent-list');

        // add trapping for 3rd level
        if (!parentTargetLinkContainer) {
          focusTrapping(targetListContainer, true);
        }
      }
    });

    MessageBus.subscribe('MAIN_MENULINKS_HANDLER', obj => {
      obj.event.preventDefault();

      const { event, target } = obj;
      const { clientX, clientY } = event;
      const keyed = !clientX && !clientY;
      const linkId = target.getAttribute('link-id');
      const targetParentListLink = $(`a.--parent[link-id="${linkId}"]`, menuList);
      const parentListContainer = $(`ul[list-id="0"]`, menuList);


      MessageBus.publish('MENU_HANDLER', { noActiveMenu: true });
      MessageBus.publish('LISTLINKS_HANDLER', { event: event, target: targetParentListLink, delay: 1000 })

      parentListContainer.classList.add(IS_EXPANDED_FROM_MAINLINK);
      setTimeout(() => parentListContainer.classList.add(IS_EXPANDED), 1000);

      setTimeout(() => keyed && targetParentListLink.focus(), 1000);
    });

    MessageBus.subscribe('WINDOW_SCROLL_HANDLER', obj => {
      const { direction, scrollY } = obj;
      const { offsetHeight } = $('.dlr-navigation__inner', nav);

      const scrollPercent = (value) => {
        /*
         value should be between 0 to 100;
         scroll percent of the total window height to be triggered
       */
        return Math.round(value / 100 * window.innerHeight);
      };

      if (document.body.classList.contains(NO_SCROLL)) {
        return;
      }

      if (scrollY > offsetHeight) {
        _nav.add(IS_FIXED);
      } else {
        if (3 >= scrollY && !_nav.contains(NO_DURATION)) {
          _nav.add(NO_DURATION);
          setTimeout(() => _nav.remove(NO_DURATION), 100);
          _nav.remove(IS_FIXED);
          _body.remove(IS_DOCKED);
        }
      }

      if (!_nav.contains(IS_FIXED)) {
        return;
      }

      // hide Nav
      if (IS_UP === direction && scrollY >= lastScrollTop + scrollPercent(SHOW_NAV_AT_PERCENT)) {
        _body.contains(IS_DOCKED) && _body.remove(IS_DOCKED);
        lastScrollTop = window.scrollY;
      }

      // show Nav
      if (IS_DOWN === direction && scrollY <= lastScrollTop - scrollPercent(HIDE_NAV_AT_PERCENT)) {
        !_body.contains(IS_DOCKED) && _body.add(IS_DOCKED);
        lastScrollTop = window.scrollY;
      }
    });

    /*
      Featured Image
      switching active image by hover/focus on parent list links
    */
    MessageBus.subscribe('FEATURED_IMAGE_HANDLER', obj => {
      obj.event.preventDefault();

      const { event, target } = obj;
      const linkId = target.getAttribute('link-id');
      const featuredImgContainer = $('.dlr-navigation__featured-image', menuList);
      const activeFeaturedImg = $(`.dlr-media.${IS_ACTIVE}`, featuredImgContainer);
      const targetFeaturedImg = $(`.dlr-media.--featured-image-id-${linkId}`, featuredImgContainer);

      activeFeaturedImg.classList.remove(IS_ACTIVE);
      targetFeaturedImg.classList.add(IS_ACTIVE);
    });

    /*
      Search Form
      switching active image by hover/focus on parent list links
    */
    MessageBus.subscribe('SAERCH_HANDLER', obj => {
      setTimeout(() => searchField.focus(), 1000);
      MessageBus.publish('MENU_HANDLER', obj);
    });

    MessageBus.subscribe('SAERCH_SUBMIT_HANDLER', obj => {
      obj.preventDefault();
      window.location = `/search/${searchField.value}`;
    });


    /*
      JS Links
      switching active image by hover/focus on parent list links
    */
    MessageBus.subscribe('JS_LINKS_HANDLER', obj => {
      const jsLinks = $$('a[href*="javascript:;"]');

      jsLinks.forEach((link, index) => link.setAttribute('href', `javascript:;?id=${index}`));
    });


  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        Registering MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;

    if (document.body.classList.contains('fe-styleguide') || document.body.classList.contains('home')) {
      // document.body.classList.add('--nav-transparent');
    }

    MessageBus.publish('JS_LINKS_HANDLER');
    MessageBus.publish('INIT_LISTCONTAINER_HANDLER');
    MessageBus.publish('LISTCONTAINER_POSITIONING_HANDLER');
    onResize(resizeEvent => {
      if (lastBreakpoint == breakpoint()) return;

      MessageBus.publish('LISTCONTAINER_POSITIONING_HANDLER');
      lastBreakpoint = breakpoint();
    });

    onScroll(scrollEvent => MessageBus.publish('WINDOW_SCROLL_HANDLER', scrollEvent));

    // Event
    menuBtn.addEventListener('click', event => MessageBus.publish('MENU_HANDLER', event));
    mainSearchBtn.addEventListener('click', event => MessageBus.publish('SAERCH_HANDLER', event));
    menuSearchForm.addEventListener('submit', event => MessageBus.publish('SAERCH_SUBMIT_HANDLER', event));
    document.addEventListener('keyup', event => event.key == 'Escape' && _nav.contains(IS_EXPANDED) && MessageBus.publish('MENU_HANDLER', event));
    listLinks.forEach(link => link.addEventListener('click', event => MessageBus.publish('LISTLINKS_HANDLER', { event: event, target: link, delay: 50 })));
    mainMenuLinks.forEach(link => link.addEventListener('click', event => MessageBus.publish('MAIN_MENULINKS_HANDLER', { event: event, target: link })));
    parentListLinks.forEach(link => ['mouseover', 'focus'].forEach(Event => link.addEventListener(Event, event => MessageBus.publish('FEATURED_IMAGE_HANDLER', { event: event, target: link }))));
  },
};



// WEBPACK FOOTER //
// ../views/modules/navigation/navigation.js